import { useState } from "react";

const G   = '#1B5E35';
const GD  = '#0A2E12';
const GL  = '#EBF5EF';
const GO  = '#C8893A';
const OW  = '#F9F8F5';
const T   = '#141414';
const M   = '#5C6472';

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,300;1,400;1,600&family=Outfit:wght@300;400;500;600;700&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Outfit', sans-serif; background: white; }
  img { display: block; }

  .cit-btn-p { background: #1B5E35; color: white; padding: 14px 30px; border: none; cursor: pointer; font: 600 12px/1 'Outfit'; letter-spacing: 0.1em; text-transform: uppercase; transition: background 0.2s ease; display: inline-block; }
  .cit-btn-p:hover { background: #0A2E12; }
  .cit-btn-o { background: transparent; color: #1B5E35; padding: 13px 30px; border: 2px solid #1B5E35; cursor: pointer; font: 600 12px/1 'Outfit'; letter-spacing: 0.1em; text-transform: uppercase; transition: all 0.2s ease; display: inline-block; }
  .cit-btn-o:hover { background: #1B5E35; color: white; }
  .cit-btn-w { background: white; color: #1B5E35; padding: 14px 30px; border: none; cursor: pointer; font: 700 12px/1 'Outfit'; letter-spacing: 0.1em; text-transform: uppercase; display: inline-block; }
  .cit-btn-ghost { background: transparent; color: white; padding: 12px 28px; border: 2px solid rgba(255,255,255,0.4); cursor: pointer; font: 600 12px/1 'Outfit'; letter-spacing: 0.1em; text-transform: uppercase; transition: all 0.2s; }
  .cit-btn-ghost:hover { border-color: white; background: rgba(255,255,255,0.08); }

  .cit-nav-link { font: 500 11px/1 'Outfit'; letter-spacing: 0.1em; text-transform: uppercase; color: #141414; cursor: pointer; padding-bottom: 3px; border-bottom: 2px solid transparent; transition: all 0.2s; white-space: nowrap; }
  .cit-nav-link:hover, .cit-nav-link.active { color: #1B5E35; border-bottom-color: #1B5E35; }

  .cit-label { font: 700 10px/1 'Outfit'; letter-spacing: 0.22em; text-transform: uppercase; color: #C8893A; }

  .cit-h1 { font-family: 'Cormorant Garamond', serif; font-size: clamp(40px, 5.5vw, 72px); font-weight: 600; line-height: 1.08; color: #141414; }
  .cit-h2 { font-family: 'Cormorant Garamond', serif; font-size: clamp(32px, 4vw, 54px); font-weight: 600; line-height: 1.12; color: #141414; }
  .cit-h3 { font-family: 'Cormorant Garamond', serif; font-size: clamp(22px, 3vw, 36px); font-weight: 600; line-height: 1.2; color: #141414; }
  .cit-body { font-size: 16px; line-height: 1.9; color: #5C6472; }

  .cit-card { background: white; border: 1px solid #e2eae4; transition: box-shadow 0.3s ease, transform 0.3s ease; }
  .cit-card:hover { box-shadow: 0 10px 40px rgba(27,94,53,0.1); transform: translateY(-3px); }

  .cit-sector { padding: 32px; border: 1px solid #e2eae4; transition: all 0.25s; }
  .cit-sector:hover { border-color: #1B5E35; background: #EBF5EF; }

  .cit-hr { height: 1px; background: #e2eae4; border: none; }

  .page-wrap { max-width: 1200px; margin: 0 auto; padding: 0 5%; }

  @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
  .fade-up { animation: fadeUp 0.65s ease forwards; }

  .hero-grid { display: grid; grid-template-columns: 55% 45%; gap: 48px; align-items: center; }
  .two-col   { display: grid; grid-template-columns: 1fr 1fr; gap: 72px; }
  .three-col { display: grid; grid-template-columns: repeat(3, 1fr); }
  .three-col-gap { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  .four-col  { display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px; }
  .six-col   { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
  .stats-row { display: grid; grid-template-columns: repeat(5, 1fr); }
  .footer-grid { display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 48px; }

  .svc-row { display: grid; grid-template-columns: 1fr 1fr; gap: 72px; padding: 64px 0; align-items: start; }
`;

// ─── NAV ───────────────────────────────────────────────────────────────────────
const Nav = ({ page, nav }) => (
  <nav style={{ background: 'white', borderBottom: '1px solid #e2eae4', position: 'sticky', top: 0, zIndex: 100 }}>
    <div className="page-wrap" style={{ display: 'flex', alignItems: 'center', height: 68 }}>
      <img
        src="https://www.citsys.com/wp-content/uploads/2019/02/citsys-logo.png"
        alt="CITSYS" style={{ height: 36, cursor: 'pointer', objectFit: 'contain' }}
        onClick={() => nav('home')}
      />
      <div style={{ flex: 1 }} />
      <div style={{ display: 'flex', gap: 28, alignItems: 'center' }}>
        {[['services','Services'],['sectors','Sectors'],['about','About'],['why','Why We Exist'],['partners','Partners']].map(([id, lbl]) => (
          <span key={id} className={`cit-nav-link${page===id?' active':''}`} onClick={() => nav(id)}>{lbl}</span>
        ))}
        <button className="cit-btn-p" style={{ marginLeft: 8, padding: '10px 22px' }} onClick={() => nav('contact')}>Get In Touch</button>
      </div>
    </div>
  </nav>
);

// ─── FOOTER ────────────────────────────────────────────────────────────────────
const Footer = ({ nav }) => (
  <footer style={{ background: '#061508', padding: '60px 5% 28px' }}>
    <div style={{ maxWidth: 1200, margin: '0 auto' }}>
      <div className="footer-grid" style={{ marginBottom: 48 }}>
        <div>
          <img src="https://www.citsys.com/wp-content/uploads/2019/02/citsys-logo.png" alt="CITSYS" style={{ height: 32, marginBottom: 20, objectFit: 'contain' }} />
          <p style={{ fontSize: 14, lineHeight: 1.85, color: 'rgba(255,255,255,0.55)', marginBottom: 20, maxWidth: 260 }}>Africa's leading cybersecurity and IT services company. Securing, Supporting, and Scaling organizations since 2007.!!!??</p>
          <a href="mailto:hello@citsys.com" style={{ display: 'block', fontSize: 13, color: GO, marginBottom: 4, textDecoration: 'none' }}>hello@citsys.com</a>
          <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)' }}>+233 302 924 323</span>
        </div>
        {[
          { title: 'Services', items: [['services','Managed Security (MSSP)'],['services','Penetration Testing'],['services','Compliance & Audits'],['services','Incident Response'],['services','IT Support']] },
          { title: 'Company',  items: [['about','About Us'],['why','Why We Exist'],['sectors','Sectors'],['partners','Partners'],['contact','Contact']] },
          { title: 'Sectors',  items: [['sectors','Banking & Finance'],['sectors','Government & Defense'],['sectors','Critical Infrastructure'],['sectors','Media & Broadcasting'],['sectors','Education']] },
        ].map(col => (
          <div key={col.title}>
            <p style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'white', marginBottom: 20 }}>{col.title}</p>
            {col.items.map(([p, lbl]) => (
              <div key={lbl} style={{ fontSize: 13, marginBottom: 11, cursor: 'pointer', color: 'rgba(255,255,255,0.5)', transition: 'color 0.2s' }}
                onClick={() => nav(p)}
                onMouseEnter={e => e.currentTarget.style.color='white'}
                onMouseLeave={e => e.currentTarget.style.color='rgba(255,255,255,0.5)'}>
                {lbl}
              </div>
            ))}
          </div>
        ))}
      </div>
      <div style={{ height: 1, background: 'rgba(255,255,255,0.07)', marginBottom: 24 }} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
        <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)' }}>© 2025 CITSYS Ltd. All rights reserved. · F142A/2 Lokko Road, Anohor Road, Accra, Ghana.</p>
        <p style={{ fontSize: 15, fontFamily: "'Cormorant Garamond',serif", fontStyle: 'italic', color: GO }}>Africa's Cyber Shield. Your Growth Engine.</p>
      </div>
    </div>
  </footer>
);

// ─── HOME ──────────────────────────────────────────────────────────────────────
const Home = ({ nav }) => (
  <div className="fade-up">

    {/* HERO */}
    <section style={{ background: OW, padding: '80px 5% 0' }}>
      <div className="page-wrap" style={{ padding: 0 }}>
        <div className="hero-grid" style={{ minHeight: '74vh', paddingBottom: 60 }}>
          <div>
            <p className="cit-label" style={{ marginBottom: 28 }}>Africa's Leading Cybersecurity Partner · Since 2007</p>
            <h1 className="cit-h1" style={{ marginBottom: 28 }}>
              Your Shield.<br/>
              <em style={{ color: G, fontStyle: 'italic' }}>Your Growth Engine.</em><br/>
              Your Partner.
            </h1>
            <p className="cit-body" style={{ maxWidth: 490, marginBottom: 40 }}>
              CITSYS has secured, supported, and scaled Africa's most consequential organizations since 2007 — from the Bank of Ghana to Ghana Armed Forces. We are not a vendor. We are your strategic security partner.
            </p>
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 56 }}>
              <button className="cit-btn-p" onClick={() => nav('services')}>Explore Services</button>
              <button className="cit-btn-o" onClick={() => nav('why')}>Why We Exist</button>
            </div>
            <div style={{ display: 'flex', gap: 44 }}>
              {[['90%','Client Retention'],['18+','Years Operating'],['500+','Orgs Served']].map(([n,l]) => (
                <div key={l}>
                  <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 40, fontWeight: 700, color: G, lineHeight: 1 }}>{n}</div>
                  <div style={{ fontSize: 12, color: M, marginTop: 5, fontWeight: 500, letterSpacing: '0.03em' }}>{l}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Hero Visual Panel */}
          <div>
            <div style={{ background: G, position: 'relative', overflow: 'hidden', height: 510 }}>
              <div style={{ position: 'absolute', top: -50, right: -50, width: 260, height: 260, borderRadius: '50%', background: 'rgba(255,255,255,0.03)' }} />
              <div style={{ position: 'absolute', top: 70, right: 70, width: 110, height: 110, borderRadius: '50%', border: '1px solid rgba(200,137,58,0.35)' }} />
              <div style={{ position: 'absolute', top: 36, left: 36, right: 36 }}>
                <div style={{ width: 36, height: 3, background: GO, marginBottom: 24 }} />
                <p style={{ fontSize: 10, color: 'rgba(255,255,255,0.45)', letterSpacing: '0.18em', textTransform: 'uppercase', marginBottom: 18, fontFamily: "'Outfit',sans-serif", fontWeight: 600 }}>Trusted By</p>
                {['Bank of Ghana','Ghana Armed Forces','Ghana Ports & Harbours Authority','Hollard Insurance Ghana','Media General','Ashesi University','37 Military Hospital'].map(c => (
                  <div key={c} style={{ padding: '10px 0', borderBottom: '1px solid rgba(255,255,255,0.08)', fontSize: 14, color: 'rgba(255,255,255,0.82)', fontWeight: 500 }}>{c}</div>
                ))}
              </div>
              <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'rgba(0,0,0,0.25)', padding: '20px 28px', borderLeft: `3px solid ${GO}` }}>
                <p style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 17, fontStyle: 'italic', color: 'white', lineHeight: 1.6, marginBottom: 10 }}>
                  "Service is not a strategy at CITSYS. It is a lineage."
                </p>
                <p style={{ fontSize: 10, color: 'rgba(255,255,255,0.55)', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase' }}>Henry Nyako · Founder</p>
              </div>
            </div>
            <div style={{ height: 5, background: GO }} />
          </div>
        </div>
      </div>
    </section>

    {/* STATS BAR */}
    <section style={{ background: GD }}>
      <div className="page-wrap" style={{ padding: '44px 5%' }}>
        <div className="stats-row">
          {[['17+','Years of Excellence'],['500+','Clients Served'],['90%','Retention Rate'],['50K+','Users Protected Daily'],['50%','Referral-Driven Growth']].map(([n,l],i) => (
            <div key={l} style={{ textAlign:'center', padding:'0 16px', borderRight: i<4?'1px solid rgba(255,255,255,0.09)':'none' }}>
              <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize: 52, fontWeight: 700, color:'white', lineHeight:1 }}>{n}</div>
              <div style={{ fontSize:11, color:'rgba(255,255,255,0.5)', marginTop:8, fontWeight:600, letterSpacing:'0.07em', textTransform:'uppercase' }}>{l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* SECURE · SUPPORT · GROW */}
    <section style={{ padding: '100px 5%', background: 'white' }}>
      <div className="page-wrap" style={{ padding: 0 }}>
        <div style={{ textAlign:'center', marginBottom:64 }}>
          <p className="cit-label" style={{ marginBottom:18 }}>Our Framework</p>
          <h2 className="cit-h2">One Framework. Every Stage of Growth.</h2>
        </div>
        <div className="three-col" style={{ gap: 3 }}>
          {[
            { t:'Secure',  bg:G,              desc:'Enterprise-grade protection across endpoints, networks, cloud environments, and the human layer. From SIEM to Zero Trust, we architect defenses that hold under real-world pressure.' },
            { t:'Support', bg:'#1D6F40',      desc:'Proactive, always-on managed IT and security operations. Our certified engineers become an extension of your team — resolving issues before they become operational crises.' },
            { t:'Grow',    bg:GO,             desc:'Technology as a catalyst for Pan-African growth. We help you scale confidently across borders with infrastructure and compliance frameworks built for where you\'re going next.' },
          ].map(item => (
            <div key={item.t} style={{ background:item.bg, padding:'64px 44px' }}>
              <h3 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:54, fontWeight:600, color:'white', marginBottom:20 }}>{item.t}</h3>
              <div style={{ height:2, background:'rgba(255,255,255,0.3)', width:40, marginBottom:24 }} />
              <p style={{ fontSize:15, lineHeight:1.9, color:'rgba(255,255,255,0.85)' }}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* SERVICES PREVIEW */}
    <section style={{ padding:'80px 5%', background:OW }}>
      <div className="page-wrap" style={{ padding:0 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-end', marginBottom:52, flexWrap:'wrap', gap:20 }}>
          <div>
            <p className="cit-label" style={{ marginBottom:18 }}>What We Do</p>
            <h2 className="cit-h2">A Portfolio Built for the<br/>Modern Threat Landscape</h2>
          </div>
          <button className="cit-btn-o" onClick={() => nav('services')}>View All Services</button>
        </div>
        <div className="three-col-gap">
          {[
            { i:'◈', t:'Managed Security Services', d:'24/7 threat monitoring, detection, and rapid response. We operate your security function so your team can focus on the mission.' },
            { i:'◉', t:'Penetration Testing & Vulnerability Management', d:'Adversarial thinking applied to your defenses — identifying exploitable weaknesses before threat actors do.' },
            { i:'◎', t:'Cybersecurity Audits & Regulatory Compliance', d:'Aligned to Ghana Cybersecurity Act (Act 1038), BoG CISD, Data Protection Act (Act 843), and international frameworks.' },
            { i:'◆', t:'Security Awareness & Training', d:'Transforming your people into a first line of defense — building a security culture that scales across your entire organization.' },
            { i:'◇', t:'Incident Response & Management', d:'Rapid detection, containment, and recovery — minimizing impact and restoring operations when incidents strike.' },
            { i:'○', t:'IT Support & Managed IT Services', d:'Enterprise IT operations across large, distributed, and hybrid environments — from helpdesk to infrastructure architecture.' },
          ].map(s => (
            <div key={s.t} className="cit-card" style={{ padding:'36px 30px' }}>
              <div style={{ fontSize:26, color:G, marginBottom:20 }}>{s.i}</div>
              <h4 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:22, fontWeight:600, color:T, marginBottom:14, lineHeight:1.3 }}>{s.t}</h4>
              <p style={{ fontSize:14, color:M, lineHeight:1.85 }}>{s.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* PAN-AFRICAN REACH */}
    <section style={{ padding:'80px 5%', background:'white' }}>
      <div className="page-wrap" style={{ padding:0 }}>
        <div className="two-col" style={{ alignItems:'center' }}>
          <div>
            <p className="cit-label" style={{ marginBottom:18 }}>Pan-African Vision</p>
            <h2 className="cit-h2" style={{ marginBottom:28 }}>Built in Ghana.<br/>Built for Africa.</h2>
            <p className="cit-body" style={{ marginBottom:24 }}>CITSYS began in Accra with a single mission: to ensure African organizations had access to the same caliber of cybersecurity expertise as any global institution. Eighteen years later, that mission has expanded across borders — and we're just getting started.</p>
            <p className="cit-body" style={{ marginBottom:36 }}>Our Pan-African expansion brings CITSYS's relationship-first approach, regulatory fluency, and certified technical capability to organizations across the continent. We don't just know the threat landscape — we know the regulatory environment and business realities unique to African markets.</p>
            <button className="cit-btn-p" onClick={() => nav('about')}>Our Story</button>
          </div>
          <div>
            {[
              { s:'Banking & Financial Services', e:'Bank of Ghana · Hollard Insurance' },
              { s:'Government & National Defense', e:'Ghana Armed Forces' },
              { s:'Critical Infrastructure', e:'Ghana Ports & Harbours Authority' },
              { s:'Media & Broadcasting', e:'Media General · Multimedia Group' },
              { s:'Higher Education', e:'Ashesi University' },
              { s:'Retail & FMCG', e:'Melcom Ghana · Shoprite Ghana' },
            ].map(item => (
              <div key={item.s} style={{ display:'flex', gap:18, padding:'16px 0', borderBottom:'1px solid #e2eae4', alignItems:'flex-start' }}>
                <div style={{ width:8, height:8, borderRadius:'50%', background:GO, flexShrink:0, marginTop:5 }} />
                <div>
                  <div style={{ fontSize:14, fontWeight:600, color:T, marginBottom:2 }}>{item.s}</div>
                  <div style={{ fontSize:13, color:M }}>{item.e}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

    {/* GOVERNMENT & INSTITUTIONAL */}
    <section style={{ padding:'80px 5%', background:GD }}>
      <div className="page-wrap" style={{ padding:0 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-end', marginBottom:52, flexWrap:'wrap', gap:20 }}>
          <div>
            <p className="cit-label" style={{ marginBottom:18, color:GO }}>Government & Institutional</p>
            <h2 className="cit-h2" style={{ color:'white' }}>Trusted Where It Matters Most</h2>
          </div>
          <button className="cit-btn-ghost" onClick={() => nav('sectors')}>All Sectors</button>
        </div>
        <div className="four-col">
          {[
            { n:'Bank of Ghana', s:'Central Banking', d:'Ghana\'s apex bank — managing SIEM deployment and security operations.' },
            { n:'Ghana Armed Forces', s:'National Defense', d:'Cybersecurity and endpoint protection for national defense infrastructure.' },
            { n:'Ghana Ports & Harbours Authority', s:'Critical Infrastructure', d:'IT security and managed services for one of West Africa\'s key ports.' },
            { n:'37 Military Hospital', s:'Healthcare & Defense', d:'Protecting sensitive healthcare and defense data with enterprise-grade security.' },
          ].map(c => (
            <div key={c.n} style={{ padding:'28px 24px', borderTop:`3px solid ${GO}`, background:'rgba(255,255,255,0.04)' }}>
              <div style={{ fontSize:15, fontWeight:700, color:'white', marginBottom:4, lineHeight:1.3 }}>{c.n}</div>
              <div style={{ fontSize:11, color:GO, fontWeight:600, letterSpacing:'0.07em', textTransform:'uppercase', marginBottom:14 }}>{c.s}</div>
              <p style={{ fontSize:13, color:'rgba(255,255,255,0.6)', lineHeight:1.75 }}>{c.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* TESTIMONIALS */}
    <section style={{ padding:'80px 5%', background:GL }}>
      <div className="page-wrap" style={{ padding:0 }}>
        <p className="cit-label" style={{ marginBottom:18 }}>What Our Clients Say</p>
        <h2 className="cit-h2" style={{ marginBottom:52 }}>Relationships Built on Results</h2>
        <div className="three-col-gap">
          {[
            { q:'The professionalism and great service support has been sustained over the years. They are always available — and sometimes proactively check on us to ensure systems are running smoothly.', n:'Emmanuel Arhin', r:'IT Infrastructure Manager', o:'Hollard Insurance Ghana Ltd.' },
            { q:'They exhibit a high sense of professionalism in their operations. I am very satisfied with the service offered by CITSYS. I will certainly recommend them.', n:'Eugene Yarboi Mensa', r:'Head of IT', o:'Quality Insurance Company Ltd.' },
            { q:'I was satisfied by CITSYS\'s services. I would recommend CITSYS anytime.', n:'Lt. Col. Elikem Fiamavle', r:'AG Director', o:'Ghana Armed Forces' },
          ].map(t => (
            <div key={t.n} style={{ background:'white', padding:'36px', borderTop:`3px solid ${G}`, boxShadow:'0 2px 20px rgba(0,0,0,0.05)' }}>
              <p style={{ fontSize:15, color:M, lineHeight:1.85, fontStyle:'italic', marginBottom:28 }}>"{t.q}"</p>
              <div style={{ borderTop:'1px solid #e2eae4', paddingTop:20 }}>
                <div style={{ fontWeight:700, fontSize:14, color:T }}>{t.n}</div>
                <div style={{ fontSize:13, color:G, marginTop:3 }}>{t.r}</div>
                <div style={{ fontSize:12, color:M, marginTop:2 }}>{t.o}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section style={{ background:G, padding:'72px 5%' }}>
      <div className="page-wrap" style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:40, flexWrap:'wrap', padding:0 }}>
        <div>
          <h2 className="cit-h2" style={{ color:'white', marginBottom:14 }}>Ready to Secure, Support, and Grow?</h2>
          <p style={{ fontSize:16, color:'rgba(255,255,255,0.8)', lineHeight:1.7, maxWidth:520 }}>Engage CITSYS today and take the first step toward a resilient, future-ready organization built for Africa's digital frontier.</p>
        </div>
        <div style={{ display:'flex', gap:16, flexShrink:0, flexWrap:'wrap' }}>
          <button className="cit-btn-w" onClick={() => nav('contact')}>Get In Touch</button>
          <button className="cit-btn-ghost" onClick={() => nav('why')}>Why We Exist</button>
        </div>
      </div>
    </section>
  </div>
);

// ─── WHY WE EXIST ──────────────────────────────────────────────────────────────
const WhyExist = () => (
  <div className="fade-up">

    <section style={{ background:GD, padding:'100px 5%' }}>
      <div className="page-wrap" style={{ textAlign:'center', padding:0 }}>
        <p className="cit-label" style={{ marginBottom:24, color:GO }}>Our Purpose</p>
        <h1 className="cit-h1" style={{ color:'white', marginBottom:28 }}>Why We Exist</h1>
        <p style={{ fontSize:20, color:'rgba(255,255,255,0.72)', lineHeight:1.8, fontFamily:"'Cormorant Garamond',serif", fontStyle:'italic', maxWidth:680, margin:'0 auto' }}>
          Before you understand CITSYS, you need to understand the family it came from.<br/>Because this company didn't begin in 2007.
        </p>
      </div>
    </section>

    <section style={{ padding:'100px 5%', background:'white' }}>
      <div style={{ maxWidth:780, margin:'0 auto' }}>
        <p className="cit-label" style={{ marginBottom:24 }}>The Lineage</p>
        <h2 className="cit-h2" style={{ marginBottom:40 }}>Some People Are Born to Serve.<br/>We Were Raised To.</h2>
        <p className="cit-body" style={{ marginBottom:28 }}>
          This company began long before 2007 — in the classrooms our founder's grandparents taught in, in the communities their generation served, and in the quiet, consistent way his father moved through the world: always giving, always serving, always making the lives around him better than he found them.
        </p>
        <p className="cit-body" style={{ marginBottom:48 }}>
          He grew up watching what genuine service looks like. Not the performative kind. Not the transactional kind. The kind where you show up fully — for people who need you, whether or not it is convenient, whether or not it benefits you — because you understand that your gifts exist to be given. That was the value the family lived by. It is the value CITSYS has been built around.
        </p>
        <div style={{ borderLeft:`4px solid ${GO}`, paddingLeft:28, marginBottom:0 }}>
          <p style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:28, fontStyle:'italic', color:G, lineHeight:1.6 }}>
            Service is not a strategy at CITSYS.<br/>It is a lineage.
          </p>
        </div>
      </div>
    </section>

    <section style={{ padding:'80px 5%', background:OW }}>
      <div style={{ maxWidth:780, margin:'0 auto' }}>
        <p className="cit-label" style={{ marginBottom:24 }}>The Observation</p>
        <h2 className="cit-h2" style={{ marginBottom:36 }}>Businesses Across Africa Were Being Left Behind.</h2>
        <p className="cit-body" style={{ marginBottom:24 }}>Not because of a lack of ambition. But because of a lack of access to the right technology at the right time — and trusted partners who understood both the technical and business realities they faced.</p>
        <p className="cit-body" style={{ marginBottom:24 }}>Henry spent his early career at the forefront of IT — from systems administration at Soft Tribe Co. Ltd., to managing information systems for Church World Service, to lecturing in Information Technology at Southwark College in the UK. These experiences gave him a rare dual perspective: the technical depth of an engineer and the strategic lens of a business operator.</p>
        <p className="cit-body" style={{ marginBottom:48 }}>What he saw, repeatedly, was the same painful gap: organizations struggling without experienced guidance — overpaying for the wrong solutions, underinvesting in security, and falling further behind. He returned to Ghana with a mission to change that.</p>
        <div style={{ background:G, padding:'36px 40px', display:'flex', gap:20, alignItems:'flex-start' }}>
          <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:80, color:`${GO}`, lineHeight:0.6, flexShrink:0, marginTop:10 }}>"</div>
          <div>
            <p style={{ fontSize:19, color:'white', fontFamily:"'Cormorant Garamond',serif", fontStyle:'italic', lineHeight:1.75, marginBottom:16 }}>We understand firsthand the pain and challenges business operators face in getting the right software and solutions at the best value. We believe technology should be a catalyst for growth — not a barrier to it.</p>
            <p style={{ fontSize:10, color:'rgba(255,255,255,0.5)', fontWeight:700, letterSpacing:'0.16em', textTransform:'uppercase' }}>Henry Nyako · Founder · CITSYS Ltd.</p>
          </div>
        </div>
      </div>
    </section>

    <section style={{ padding:'80px 5%', background:GD }}>
      <div style={{ maxWidth:780, margin:'0 auto' }}>
        <p className="cit-label" style={{ marginBottom:24, color:GO }}>Accra, 2007</p>
        <h2 className="cit-h2" style={{ color:'white', marginBottom:40 }}>The Invoice That Changed Everything.</h2>
        <p style={{ fontSize:17, lineHeight:1.95, color:'rgba(255,255,255,0.72)', marginBottom:24 }}>An NGO based in Kumasi had found CITSYS on the ESET distributor's website. They were in Accra — their last night before heading home — and they needed antivirus protection for their computers. They reached out. A meeting was arranged.</p>
        <p style={{ fontSize:17, lineHeight:1.95, color:'rgba(255,255,255,0.72)', marginBottom:24 }}>There were no offices to impress them with. No long track record to point to. No team behind him. There was just him, the solution he believed in, and a conversation.</p>
        <p style={{ fontSize:17, lineHeight:1.95, color:'rgba(255,255,255,0.72)', marginBottom:24 }}>They decided to go ahead. And then they did something that stopped him cold: they paid in full — upfront — before he had even generated their license.</p>
        <p style={{ fontSize:17, lineHeight:1.95, color:'rgba(255,255,255,0.72)', marginBottom:44 }}>He sat in that hotel lobby and generated his very first invoice on the spot. Imperfect. Entirely improvised. And the most important piece of paper he has ever produced. He went back to the office that evening and immediately generated their licenses. He delivered on the trust a stranger had placed in a company that was, at that moment, little more than a belief and a business card.</p>
        <div style={{ borderLeft:`4px solid ${GO}`, paddingLeft:32 }}>
          <p style={{ fontSize:27, fontFamily:"'Cormorant Garamond',serif", color:'white', fontStyle:'italic', lineHeight:1.6 }}>
            That NGO is still our client today.<br/>Nearly eighteen years later.
          </p>
        </div>
      </div>
    </section>

    <section style={{ padding:'100px 5%', background:'white' }}>
      <div style={{ maxWidth:780, margin:'0 auto' }}>
        <p className="cit-label" style={{ marginBottom:24 }}>A Personal Note From The Founder</p>
        <div style={{ padding:'48px', background:OW, borderTop:`4px solid ${G}` }}>
          <p style={{ fontSize:19, fontFamily:"'Cormorant Garamond',serif", fontStyle:'italic', lineHeight:1.85, color:T, marginBottom:32 }}>
            "In 2007, an organization I had never met before trusted me with their money before I had earned it. They paid first and asked questions later — because something in our conversation told them I was someone who would deliver. I have spent every day of the last seventeen years making sure that instinct was right. Not just for them. For every client who has ever placed their trust in us. That is not a business model. That is a promise. And it is one we intend to keep for the next seventeen years — and beyond."
          </p>
          <div style={{ display:'flex', alignItems:'center', gap:18 }}>
            <div style={{ width:44, height:2, background:G }} />
            <div>
              <div style={{ fontWeight:700, fontSize:14, color:T }}>Henry Nyako</div>
              <div style={{ fontSize:13, color:G, marginTop:3 }}>Founder & Strategic Board Member · CITSYS Ltd.</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section style={{ padding:'80px 5%', background:OW }}>
      <div className="page-wrap" style={{ padding:0 }}>
        <p className="cit-label" style={{ textAlign:'center', marginBottom:18 }}>How We Live This Out</p>
        <h2 className="cit-h2" style={{ textAlign:'center', marginBottom:60 }}>The Commitments We Keep. Every Day.</h2>
        <div className="six-col">
          {[
            ['01','Client Before Revenue','When we have had to choose between short-term revenue and long-term client interest, we have chosen the client. Every time. Without exception.'],
            ['02','Competence Is Not Optional','Every CITSYS engineer holds vendor certifications across our full technology partner ecosystem. We earn the right to advise by staying ahead of the threat landscape.'],
            ['03','Value at Every Phase','We exist to help clients access the most appropriate technology at each growth phase — not to upsell complexity they don\'t need.'],
            ['04','Relationships Over Transactions','More than 50% of new business comes from existing clients recommending CITSYS to peers. That is the metric we truly optimize for.'],
            ['05','Africa as the Opportunity','Africa\'s most ambitious organizations deserve the same enterprise-grade security capabilities as any global institution. That is why we\'re here.'],
            ['06','Deliver on the Trust','From that hotel lobby invoice in 2007 to every engagement since — our standard is simple: deliver on the trust placed in us. Every time.'],
          ].map(([n,t,d]) => (
            <div key={n} style={{ padding:'36px', background:'white', borderBottom:`3px solid ${G}` }}>
              <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:60, color:'#ECF5EF', fontWeight:700, lineHeight:1, marginBottom:-4 }}>{n}</div>
              <h4 style={{ fontSize:16, fontWeight:600, color:T, marginBottom:14, marginTop:10, lineHeight:1.3 }}>{t}</h4>
              <p style={{ fontSize:14, color:M, lineHeight:1.85 }}>{d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

// ─── SERVICES ──────────────────────────────────────────────────────────────────
const Services = ({ nav }) => (
  <div className="fade-up">
    <section style={{ background:GD, padding:'80px 5%' }}>
      <div className="page-wrap" style={{ padding:0 }}>
        <p className="cit-label" style={{ marginBottom:24, color:GO }}>What We Do</p>
        <h1 className="cit-h1" style={{ color:'white', marginBottom:20 }}>A Comprehensive Portfolio Built for the Modern Threat Landscape</h1>
        <p style={{ fontSize:17, color:'rgba(255,255,255,0.7)', lineHeight:1.8, maxWidth:600 }}>We serve organizations from 5 to 10,000+ staff — tailoring every engagement to your scale, risk profile, and Pan-African ambitions.</p>
      </div>
    </section>
    <section style={{ padding:'80px 5%', background:'white' }}>
      <div className="page-wrap" style={{ padding:0 }}>
        {[
          { icon:'◈', t:'Managed Security Services (MSSP)', d:'24/7 threat monitoring, detection, and rapid response. Our SOC analysts operate as an extension of your team — triaging alerts, investigating incidents, and ensuring critical threats never go unnoticed.', caps:['Security Operations Center (SOC) as a Service','Threat Detection & Intelligence','SIEM Management (Exabeam)','User & Entity Behavior Analytics (UEBA)','Cloud Security Monitoring'] },
          { icon:'◉', t:'Offensive Security & Risk Assessments', d:'Proactive identification of exploitable weaknesses before adversaries find them. Our certified ethical hackers think like attackers — systematically stress-testing your defenses across every attack surface.', caps:['Network & Application Penetration Testing','Red Team Exercises','Vulnerability Assessment & Management','Attack Surface Mapping','Security Posture Benchmarking'] },
          { icon:'◎', t:'Cybersecurity Audits & Regulatory Compliance', d:'Supporting governance, assurance, and regulatory obligations. We map your controls to Ghana\'s Cybersecurity Act (Act 1038), the Data Protection Act (Act 843), BoG CISD directives, and international frameworks.', caps:['Ghana Cybersecurity Act (Act 1038) Compliance','Bank of Ghana CISD Alignment','ISO 27001 Readiness Assessment','Data Protection Act (Act 843) Review','Sector-Specific Regulatory Mapping'] },
          { icon:'◆', t:'Cybersecurity Awareness & Training', d:'Building human-centric security resilience — transforming your people into a first line of defense. Because the most sophisticated technical controls can be undone by a single phishing click.', caps:['Phishing Simulation Programs','Executive Security Briefings','Role-Based Security Training','Incident Response Tabletop Exercises','Security Culture Assessments'] },
          { icon:'◇', t:'Incident Response & Management', d:'Rapid detection, containment, and recovery — minimizing impact when incidents occur. Our IR team operates with structured playbooks, ensuring every response is measured, documented, and improves your future resilience.', caps:['24/7 Incident Response Retainer','Digital Forensics & Investigation','Ransomware Recovery Planning','Business Continuity Support','Post-Incident Review & Hardening'] },
          { icon:'○', t:'IT Support & Managed IT Services', d:'Enterprise IT operations support across large, distributed, and hybrid environments. From frontline helpdesk to infrastructure architecture — we keep your technology running so your business never stops.', caps:['Helpdesk & End-User Support','Infrastructure Management','Cloud & Hybrid Architecture','IT Project Management','Software Procurement & Licensing'] },
        ].map((s,i) => (
          <div key={s.t}>
            <div className="svc-row">
              <div style={{ order: i%2===0?0:1 }}>
                <div style={{ fontSize:36, color:G, marginBottom:24 }}>{s.icon}</div>
                <h2 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:36, fontWeight:600, color:T, marginBottom:20, lineHeight:1.2 }}>{s.t}</h2>
                <p className="cit-body" style={{ marginBottom:32 }}>{s.d}</p>
                <button className="cit-btn-p" onClick={() => nav('contact')}>Enquire About This Service</button>
              </div>
              <div style={{ background:OW, padding:'36px', order: i%2===0?1:0 }}>
                <p style={{ fontSize:10, fontWeight:700, letterSpacing:'0.16em', textTransform:'uppercase', color:G, marginBottom:20 }}>Capabilities Include</p>
                {s.caps.map(c => (
                  <div key={c} style={{ display:'flex', gap:14, alignItems:'center', padding:'12px 0', borderBottom:'1px solid #e2eae4' }}>
                    <div style={{ width:7, height:7, borderRadius:'50%', background:GO, flexShrink:0 }} />
                    <span style={{ fontSize:14, color:T }}>{c}</span>
                  </div>
                ))}
              </div>
            </div>
            {i<5 && <hr className="cit-hr" />}
          </div>
        ))}
      </div>
    </section>
  </div>
);

// ─── ABOUT ─────────────────────────────────────────────────────────────────────
const About = ({ nav }) => (
  <div className="fade-up">
    <section style={{ background:OW, padding:'100px 5%' }}>
      <div className="page-wrap" style={{ padding:0 }}>
        <div className="two-col" style={{ alignItems:'center' }}>
          <div>
            <p className="cit-label" style={{ marginBottom:24 }}>Our Story</p>
            <h1 className="cit-h1" style={{ marginBottom:28, lineHeight:1.15 }}>18 Years.<br/>One Promise.<br/>Renewed Every Day.</h1>
            <p className="cit-body" style={{ marginBottom:24 }}>CITSYS was founded in 2007 by Henry Nyako — an engineer, lecturer, and strategist who saw a fundamental gap in Africa's technology landscape and decided to do something about it.</p>
            <p className="cit-body" style={{ marginBottom:36 }}>What began as a belief and a business card in a hotel lobby in Accra has grown into one of Africa's most trusted cybersecurity and IT services companies — 20+ certified professionals, a world-class partner ecosystem, and a reputation built almost entirely on referrals.</p>
            <div style={{ display:'flex', gap:16, flexWrap:'wrap' }}>
              <button className="cit-btn-p" onClick={() => nav('why')}>Read Why We Exist</button>
              <button className="cit-btn-o" onClick={() => nav('contact')}>Work With Us</button>
            </div>
          </div>
          <div>
            <div style={{ background:G, padding:'52px 44px', marginBottom:3 }}>
              <p style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:20, fontStyle:'italic', lineHeight:1.8, color:'rgba(255,255,255,0.9)', marginBottom:32 }}>
                "When we have had to choose between short-term revenue and long-term client interest, we have chosen the client. Every time. Without exception."
              </p>
              <div style={{ borderTop:'1px solid rgba(255,255,255,0.18)', paddingTop:24 }}>
                <div style={{ fontWeight:700, color:'white', fontSize:14 }}>Henry Nyako</div>
                <div style={{ fontSize:13, color:GO, marginTop:3 }}>Founder & Strategic Board Member · CITSYS Ltd.</div>
              </div>
            </div>
            <div style={{ background:GO, padding:'22px 44px', display:'flex', gap:20, alignItems:'center' }}>
              <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:42, fontWeight:700, color:'white', lineHeight:1 }}>18</div>
              <div style={{ fontSize:14, color:'rgba(255,255,255,0.9)', lineHeight:1.5 }}>years of building relationships that outlast contracts</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section style={{ padding:'80px 5%', background:'white' }}>
      <div style={{ maxWidth:900, margin:'0 auto' }}>
        <p className="cit-label" style={{ marginBottom:18, textAlign:'center' }}>The Founder's Journey</p>
        <h2 className="cit-h2" style={{ textAlign:'center', marginBottom:64 }}>The Engineer Who Became a Strategist</h2>
        {[
          { y:'Early Career', o:'Soft Tribe Co. Ltd.', r:'Systems Administration', d:'Built deep technical foundations in IT infrastructure — learning how enterprise technology operates at the operational level, where reliability is non-negotiable.' },
          { y:'Development Sector', o:'Church World Service', r:'Information Systems Management', d:'Managed technology for international development organizations — understanding how institutions with real-world missions depend critically on reliable, resilient systems.' },
          { y:'International', o:'Southwark College, UK', r:'Lecturer in Information Technology', d:'Taught Information Technology in the UK, developing the pedagogical and strategic lens that now shapes how CITSYS educates and advises enterprise clients.' },
          { y:'2007 — Present', o:'CITSYS Ltd.', r:'Founder & Strategic Board Member', d:'Returned to Ghana with a mission: to give African organizations access to the right technology, the right guidance, and a partner who genuinely cares about their long-term success.' },
        ].map((item, i) => (
          <div key={item.y} style={{ display:'flex', gap:40 }}>
            <div style={{ width:150, flexShrink:0, textAlign:'right', paddingTop:3 }}>
              <div style={{ fontSize:11, fontWeight:700, color: i===3?G:GO, textTransform:'uppercase', letterSpacing:'0.05em' }}>{item.y}</div>
            </div>
            <div style={{ display:'flex', flexDirection:'column', alignItems:'center', width:24, flexShrink:0 }}>
              <div style={{ width:14, height:14, borderRadius:'50%', background: i===3?G:GO, flexShrink:0, marginTop:2 }} />
              {i<3 && <div style={{ width:2, flex:1, background:'#e2eae4', minHeight:56 }} />}
            </div>
            <div style={{ flex:1, paddingBottom:44 }}>
              <div style={{ fontWeight:700, fontSize:16, color:T, marginBottom:3 }}>{item.o}</div>
              <div style={{ fontSize:13, color:G, marginBottom:12 }}>{item.r}</div>
              <p style={{ fontSize:14, color:M, lineHeight:1.85 }}>{item.d}</p>
            </div>
          </div>
        ))}
      </div>
    </section>

    <section style={{ padding:'80px 5%', background:GD }}>
      <div className="page-wrap" style={{ padding:0 }}>
        <p className="cit-label" style={{ marginBottom:18, color:GO }}>Our Foundation</p>
        <h2 className="cit-h2" style={{ color:'white', marginBottom:56 }}>Mission. Vision. Values.</h2>
        <div className="three-col-gap">
          {[
            { t:'Mission', c:'To protect, support, and accelerate the growth of organizations across Africa — through enterprise-grade cybersecurity and IT services delivered with integrity, deep expertise, and a genuine long-term commitment to client success.' },
            { t:'Vision', c:'To be Africa\'s most trusted cybersecurity partner — recognized not just for technical excellence, but for the depth of relationships we build and the genuine business outcomes we deliver across the continent.' },
            { t:'Values', c:'Client first. Always. Competence over shortcuts. Relationships over transactions. Long-term thinking over short-term gain. Integrity in every engagement. Service as a way of life, not a business strategy.' },
          ].map(v => (
            <div key={v.t} style={{ borderTop:`2px solid ${GO}`, paddingTop:28 }}>
              <h3 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:36, color:'white', marginBottom:20 }}>{v.t}</h3>
              <p style={{ fontSize:15, color:'rgba(255,255,255,0.68)', lineHeight:1.9 }}>{v.c}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

// ─── SECTORS ───────────────────────────────────────────────────────────────────
const Sectors = () => (
  <div className="fade-up">
    <section style={{ background:GD, padding:'80px 5%' }}>
      <div className="page-wrap" style={{ padding:0 }}>
        <p className="cit-label" style={{ marginBottom:24, color:GO }}>Sectors We Serve</p>
        <h1 className="cit-h1" style={{ color:'white', marginBottom:20 }}>Trusted Across Africa's Most Critical Industries</h1>
        <p style={{ fontSize:17, color:'rgba(255,255,255,0.7)', lineHeight:1.8, maxWidth:600 }}>We understand the regulatory, operational, and security demands specific to each sector we serve — because we've operated within them for nearly two decades.</p>
      </div>
    </section>
    <section style={{ padding:'80px 5%', background:'white' }}>
      <div className="page-wrap" style={{ padding:0 }}>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(2, 1fr)', gap:24 }}>
          {[
            { i:'▣', t:'Banking & Financial Services', d:'We understand the unique regulatory obligations of Ghana\'s financial sector — including BoG CISD directives, AML/CFT requirements, and the evolving fraud threat landscape. SIEM, endpoint security, and compliance frameworks tailored for financial institutions.', cs:['Bank of Ghana','Hollard Insurance','Quality Insurance Company'] },
            { i:'▲', t:'Government & National Defense', d:'CITSYS has earned the trust of Ghana\'s most sensitive government and defense institutions. We operate with the rigor, discretion, and compliance discipline that national security demands. Every engagement is delivered with appropriate clearance and governance frameworks.', cs:['Ghana Armed Forces','37 Military Hospital','Government Agencies'] },
            { i:'◆', t:'Critical Infrastructure & Logistics', d:'Ghana\'s ports, supply chains, and logistics networks are prime targets for cyber adversaries. CITSYS provides operational technology security and enterprise IT infrastructure to keep critical systems running without interruption.', cs:['Ghana Ports & Harbours Authority (GPHA)','Helios Towers Ghana'] },
            { i:'●', t:'Media & Broadcasting', d:'Media organizations face unique threats: intellectual property theft, broadcast disruption, and reputational risk from system compromise. We protect Ghana\'s leading media groups with tailored security frameworks designed for their unique operational environment.', cs:['Media General','Multimedia Group'] },
            { i:'◉', t:'Higher Education', d:'Universities manage sensitive research data, student records, and complex multi-network environments. CITSYS delivers security frameworks that protect academic institutions without impeding the open exchange of ideas and research that defines university life.', cs:['Ashesi University'] },
            { i:'▪', t:'Retail & FMCG', d:'Retail organizations handle high payment data volumes, manage distributed point-of-sale environments, and operate complex digital supply chains. We bring PCI-DSS-aligned security to Africa\'s growing retail sector.', cs:['Melcom Ghana','Shoprite Ghana'] },
            { i:'◈', t:'Telecommunications', d:'Telecom providers operate critical national infrastructure with extraordinary regulatory obligations. CITSYS brings deep sector expertise and established relationships within Ghana\'s telecommunications regulatory environment.', cs:['Leading Telecom Operators'] },
            { i:'○', t:'NGO & Development Sector', d:'Our very first client was an NGO — still with us nearly 18 years later. We understand the budget realities, donor compliance requirements, and operational contexts of development organizations working across the African continent.', cs:['Development Organizations','International NGOs'] },
          ].map(s => (
            <div key={s.t} className="cit-sector">
              <div style={{ fontSize:28, color:G, marginBottom:20 }}>{s.i}</div>
              <h3 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:28, fontWeight:600, color:T, marginBottom:16, lineHeight:1.25 }}>{s.t}</h3>
              <p style={{ fontSize:14, color:M, lineHeight:1.85, marginBottom:20 }}>{s.d}</p>
              <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
                {s.cs.map(c => <span key={c} style={{ fontSize:12, background:GL, color:G, padding:'4px 12px', fontWeight:600 }}>{c}</span>)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

// ─── PARTNERS ──────────────────────────────────────────────────────────────────
const Partners = () => (
  <div className="fade-up">
    <section style={{ background:GD, padding:'80px 5%' }}>
      <div className="page-wrap" style={{ padding:0 }}>
        <p className="cit-label" style={{ marginBottom:24, color:GO }}>Technology Ecosystem</p>
        <h1 className="cit-h1" style={{ color:'white', marginBottom:20 }}>Powered by the World's Most Trusted Technology Brands</h1>
        <p style={{ fontSize:17, color:'rgba(255,255,255,0.7)', lineHeight:1.8, maxWidth:600 }}>CITSYS partners exclusively with globally recognized, enterprise-grade technology vendors. Our engineers hold certifications across every partner in our ecosystem.</p>
      </div>
    </section>
    <section style={{ padding:'80px 5%', background:'white' }}>
      <div className="page-wrap" style={{ padding:0 }}>
        {[
          { cat:'Identity & Access Management',               ps:['CyberArk','Microsoft'] },
          { cat:'Network Security',                           ps:['Fortinet','Imperva','F5','Check Point'] },
          { cat:'Endpoint Security',                         ps:['ESET','Sophos','Kaspersky','SentinelOne'] },
          { cat:'Security Information & Event Management',    ps:['Exabeam'] },
          { cat:'AI-Driven Threat Detection',                ps:['Darktrace'] },
          { cat:'Email & Messaging Security',                ps:['Mimecast'] },
          { cat:'Data Security, Backup & Recovery',          ps:['OPSWAT','Commvault','Acronis'] },
          { cat:'Cloud & Productivity',                      ps:['Microsoft 365','Azure','NetGuardians'] },
        ].map(c => (
          <div key={c.cat} style={{ marginBottom:40 }}>
            <p className="cit-label" style={{ marginBottom:18 }}>{c.cat}</p>
            <div style={{ display:'flex', gap:12, flexWrap:'wrap' }}>
              {c.ps.map(p => (
                <div key={p} style={{ padding:'16px 28px', border:'1px solid #e2eae4', fontSize:15, fontWeight:600, color:T, minWidth:140, textAlign:'center', cursor:'default', transition:'all 0.2s' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor=G; e.currentTarget.style.color=G; e.currentTarget.style.background=GL; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor='#e2eae4'; e.currentTarget.style.color=T; e.currentTarget.style.background='white'; }}>
                  {p}
                </div>
              ))}
            </div>
            <hr className="cit-hr" style={{ marginTop:28 }} />
          </div>
        ))}
        <div style={{ background:GL, padding:'48px', textAlign:'center' }}>
          <h3 className="cit-h3" style={{ marginBottom:16 }}>100% Certified Engineering Team</h3>
          <p style={{ fontSize:16, color:M, maxWidth:560, margin:'0 auto', lineHeight:1.85 }}>Every CITSYS engineer holds vendor certifications across our full technology partner ecosystem. Quality is not optional — it is the minimum standard we hold ourselves to in every engagement.</p>
        </div>
      </div>
    </section>
  </div>
);

// ─── CONTACT ───────────────────────────────────────────────────────────────────
const Contact = () => {
  const inputStyle = { width:'100%', padding:'12px 14px', border:'1px solid #e2eae4', fontFamily:"'Outfit',sans-serif", fontSize:14, outline:'none', transition:'border 0.2s', background:'white', color:T };
  const labelStyle = { fontSize:10, fontWeight:700, color:M, display:'block', marginBottom:8, letterSpacing:'0.14em', textTransform:'uppercase' };
  return (
    <div className="fade-up">
      <section style={{ background:GD, padding:'80px 5%' }}>
        <div className="page-wrap" style={{ padding:0 }}>
          <p className="cit-label" style={{ marginBottom:24, color:GO }}>Get In Touch</p>
          <h1 className="cit-h1" style={{ color:'white', marginBottom:20 }}>Let's Start the Conversation</h1>
          <p style={{ fontSize:17, color:'rgba(255,255,255,0.7)', lineHeight:1.8, maxWidth:560 }}>Whether you're strengthening your security posture, responding to an active incident, or exploring a long-term strategic partnership — we're here.</p>
        </div>
      </section>
      <section style={{ padding:'80px 5%', background:'white' }}>
        <div className="page-wrap" style={{ padding:0 }}>
          <div className="two-col" style={{ alignItems:'start' }}>
            <div>
              <h2 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:40, marginBottom:40, color:T }}>Contact Information</h2>
              {[
                { l:'Phone', vs:['+233 302 924 323','+233 264 444 434'] },
                { l:'Email', vs:['hello@citsys.com'] },
                { l:'Address', vs:['F142A/2 Lokko Road, Anohor Road','Accra, Ghana'] },
                { l:'Website', vs:['www.citsys.com'] },
              ].map(c => (
                <div key={c.l} style={{ marginBottom:32 }}>
                  <p style={{ ...labelStyle, marginBottom:8 }}>{c.l}</p>
                  {c.vs.map(v => <div key={v} style={{ fontSize:15, color:T, lineHeight:1.65 }}>{v}</div>)}
                </div>
              ))}
              <div style={{ marginTop:44, padding:'28px 32px', background:GL, borderLeft:`4px solid ${G}` }}>
                <p style={{ fontSize:14, fontWeight:700, color:G, marginBottom:8 }}>24/7 Incident Response</p>
                <p style={{ fontSize:13, color:M, lineHeight:1.75 }}>For active security incidents requiring immediate response, contact our incident response team directly on the numbers above. We operate around the clock.</p>
              </div>
              <div style={{ marginTop:36 }}>
                <p style={{ ...labelStyle, marginBottom:16 }}>Follow Us</p>
                <div style={{ display:'flex', gap:10, flexWrap:'wrap' }}>
                  {['LinkedIn','Twitter','Facebook','Instagram','YouTube'].map(s => (
                    <div key={s} style={{ padding:'8px 16px', border:`1px solid ${G}`, fontSize:12, fontWeight:600, color:G, cursor:'pointer', transition:'all 0.2s' }}
                      onMouseEnter={e => { e.currentTarget.style.background=G; e.currentTarget.style.color='white'; }}
                      onMouseLeave={e => { e.currentTarget.style.background='transparent'; e.currentTarget.style.color=G; }}>
                      {s}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div>
              <h2 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:40, marginBottom:40, color:T }}>Send Us a Message</h2>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 }}>
                {['First Name','Last Name'].map(f => (
                  <div key={f}>
                    <label style={labelStyle}>{f}</label>
                    <input style={inputStyle} onFocus={e=>e.target.style.borderColor=G} onBlur={e=>e.target.style.borderColor='#e2eae4'} />
                  </div>
                ))}
              </div>
              {['Business Email','Company Name','Job Title'].map(f => (
                <div key={f} style={{ marginBottom:16 }}>
                  <label style={labelStyle}>{f}</label>
                  <input style={inputStyle} onFocus={e=>e.target.style.borderColor=G} onBlur={e=>e.target.style.borderColor='#e2eae4'} />
                </div>
              ))}
              <div style={{ marginBottom:16 }}>
                <label style={labelStyle}>How Can We Help?</label>
                <textarea rows={4} style={{ ...inputStyle, resize:'vertical' }} onFocus={e=>e.target.style.borderColor=G} onBlur={e=>e.target.style.borderColor='#e2eae4'} />
              </div>
              <button className="cit-btn-p" style={{ width:'100%', padding:'16px', fontSize:14 }}>Send Message</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

// ─── APP ───────────────────────────────────────────────────────────────────────
export default function App() {
  const [page, setPage] = useState('home');
  const nav = p => { setPage(p); setTimeout(() => window.scrollTo({ top:0, behavior:'smooth' }), 10); };

  return (
    <div style={{ fontFamily:"'Outfit', sans-serif", color:T, background:'white', minHeight:'100vh' }}>
      <style>{CSS}</style>
      <Nav page={page} nav={nav} />
      {page === 'home'     && <Home nav={nav} />}
      {page === 'why'      && <WhyExist />}
      {page === 'services' && <Services nav={nav} />}
      {page === 'about'    && <About nav={nav} />}
      {page === 'sectors'  && <Sectors />}
      {page === 'partners' && <Partners />}
      {page === 'contact'  && <Contact />}
      <Footer nav={nav} />
    </div>
  );
}
